import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { getCurrentLanguage } from '../core/helpers/utils';
import { generalTranslations } from '../core/helpers/translations';

// services
import { EventService } from 'src/app/core/service/event.service';
import { PlantillaService } from './plantillas.service';


// constants
import { EventType } from 'src/app/core/constants/events';
import { NgForm } from '@angular/forms';
import { Plantilla } from './plantillas.model';

@Component({
  selector: 'app-detail-plantilla',
  templateUrl: './detail-plantilla.component.html',
  styleUrls: ['./detail-plantilla.component.scss']
})
export class DetailPlantillaComponent implements OnInit {

  constructor(
    private eventService: EventService,
    private plantillaService: PlantillaService,
    private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer) { }

  // Declaro el array empleado para rellenarlo en el Oninit y usarlo con el 2-way data binding
  plantilla = <Plantilla>{};

  // ID de la plantilla
  id_plantilla!: string | null;

  model = {
    nombre: ''
  }

  ngOnInit(): void {
    let currentLanguage: string = getCurrentLanguage()
    const currentTranslations = generalTranslations[currentLanguage].TABLE;    
    this.eventService.broadcast(EventType.CHANGE_PAGE_TITLE,
      {
        title: currentTranslations.EDITAR_USUARIO,
        breadCrumbItems: [{ label: currentTranslations.USUARIOS, path: '.' }, { label: currentTranslations.EDITAR_USUARIO, path: '.', active: true }]
      }
    );

    this.id_plantilla = this.route.snapshot.paramMap.get('id');
    if (this.id_plantilla !== null) {
      this.plantillaService.getPlantilla(this.id_plantilla).subscribe(resPlantilla => {
        this.plantilla = resPlantilla;
      })
    }
  }

  onSubmit(form: NgForm) {
    const plantilla: Plantilla = {
      nombre: form.value.nombre
    }

    if (this.id_plantilla !== null) {
      this.plantillaService.updatePlantilla(this.id_plantilla, plantilla)
        .subscribe(res => {
          this.router.navigate(['/plantillas']).then(() => {
            window.location.reload();
          });
        })
    }
  }
}